import qs from 'query-string';

import { api } from '@services';

import EquipmentStatus from '@models/EquipmentStatus.model';

interface IIndexStudioEquipmentStatus {
  id: string;
  search: string;
  sort?: string;
  direction?: 'ASC' | 'DESC';
}

const indexStudioEquipmentStatus = async ({
  id,
  search,
  direction,
  sort,
}: IIndexStudioEquipmentStatus): Promise<EquipmentStatus[]> => {
  const queryObject = {
    q: search,
    sort,
    direction,
  };

  const queryString = qs.stringify(queryObject);

  const { data: equipmentStatus } = await api.get<EquipmentStatus[]>(
    `/studios/${id}/equipmentStatus?${queryString}`,
  );

  return EquipmentStatus.arrayFromApiModel(equipmentStatus);
};

export { indexStudioEquipmentStatus };
